module.exports = __webpack_public_path__ + "img/tricky-dashboard.9e179a28.jpg";